import {getDescription} from 'app/procedures/utils';

import type {ProcessForDiffContentType} from 'app/components/VersionDiffer';
import type {
  ProcessHashidSerializedType,
  ProcessVersionSerializedType,
} from 'sweet-types';

export function processOrVersionToContent(
  version: ProcessVersionSerializedType | null,
  process: ProcessHashidSerializedType
): ProcessForDiffContentType {
  const processOrProcessVersion = version != null ? version : process;
  return addGIDToProceduresHTMLURL(
    {
      url: processOrProcessVersion.url,
      name: processOrProcessVersion.name,
      html_url: processOrProcessVersion.html_url,
      is_large: undefined,
      content: processOrProcessVersion.content,
      lanes: processOrProcessVersion.lanes,
      description: getDescription(processOrProcessVersion),
      thumbnail: processOrProcessVersion.thumbnail ?? '',
    },
    process
  );
}

export function addGIDToProceduresHTMLURL(
  {content, ...other}: ProcessForDiffContentType,
  process: ProcessHashidSerializedType | ProcessVersionSerializedType
) {
  return {
    ...other,
    content:
      process == null
        ? content
        : content.map((item) => {
            if (item.type === 'processprocedure' && item.deleted !== true) {
              return {
                ...item,
                html_url: `${item.html_url}?gid=${process.hashid}`,
              };
            } else {
              return item;
            }
          }),
  };
}
